import strings from 'utils/strings';

export default function getAgeLabel(age) {
	const monthsLabel = age.months ? strings.formatString(strings.ageMonthsSuffix, age.months) : '';
	return strings.formatString(strings.ageYearsLabel, age.years, monthsLabel);
}
